var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833313 17.4999H4.16665V7.49992H0.833313V17.4999ZM19.1666 8.33325C19.1666 7.41658 18.4166 6.66658 17.5 6.66658H12.2416L13.0333 2.85825L13.0583 2.59159C13.0583 2.24992 12.9166 1.93325 12.6916 1.70825L11.8083 0.833252L6.32498 6.32492C6.01665 6.62492 5.83331 7.04158 5.83331 7.49992V15.8333C5.83331 16.7499 6.58331 17.4999 7.49998 17.4999H15C15.6916 17.4999 16.2833 17.0833 16.5333 16.4833L19.05 10.6083C19.125 10.4166 19.1666 10.2166 19.1666 9.99992V8.33325Z",
    fill: "#008954"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.8f44a097.svg";
export { ForwardRef as ReactComponent };